import { render, staticRenderFns } from "./AuthenticationFptId.vue?vue&type=template&id=70d4b3aa&scoped=true&"
import script from "./AuthenticationFptId.vue?vue&type=script&lang=js&"
export * from "./AuthenticationFptId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d4b3aa",
  null
  
)

export default component.exports